<!--ExperienceTabItem: tab item 2020/08/26 14:42:49 Sunanguang-->

<template>
  <el-carousel class="its-carousel" :height="height" direction="vertical" :autoplay="false" ref="tabCarousel" :loop="false">
    <el-carousel-item v-for="(tab, i) in tabs" :key="'tab-'+i">
      <experience-tab-item-template ref="experienceTab"  class="its-tab-container" :item="tab" @fullScreen="fullScreen"></experience-tab-item-template>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
import ExperienceTabItemTemplate from './ExperienceTabItemTemplate'
export default {
  name:'TeachingTabItem',
  components: {
    ExperienceTabItemTemplate,
  },
  props:{
    tabs:{
      type:Array,
      default:function(){
        return []
      }
    }
  },
  data(){
    return {
      height:''
    }
  },
  mounted(){
    this.height = document.documentElement.clientHeight - 80 +'px'
  },
  methods:{
    setActiveItem:function(i){
      let tabs = this.$refs.experienceTab
      if(tabs.length>0){
        tabs.forEach((tab)=>{
          tab.stopVideo()
        })
      }
      this.$refs.tabCarousel.setActiveItem(i)
    },
    fullScreen: function (isFullScreen) {
      this.$emit('fullScreen', isFullScreen)
    }
  }
}
</script>
<style scoped>
.its-tab-container{
  height: calc(100vh - 80px);
  position: relative;
  display: table;
  z-index: 2;
}
.its-carousel>>>.el-carousel__indicators{
  display: none;
}
.tab-shink{
  background-color: #F5F9FF;
}
.its-tab-item.right >>> .its-info-bg{
  background-image: url(../../../../../public/images/bg_left.png);
  background-repeat: no-repeat;
  background-size: cover;
  right: 0;
}
.its-tab-item.left >>> .its-info-bg{
  background-image: url(../../../../../public/images/bg_right.png);
  background-repeat: no-repeat;
  background-size: cover;
  left: 0;
}
.its-desc-items .its-desc{
  font-size: 24px;
  color: #404857;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 20px;
}
.its-desc-items .its-desc>>>span{
  margin-right: 13px;
  font-size: 12px;
  vertical-align: middle;
}
.its-tab-item{
  position: absolute;
  width: 1200px;
  height: 730px;
  margin: 0 auto;
  top: 50%;
  margin-top: -365px;
  left: 0;
  right: 0;
}
.its-info-bg{
  width: 750px;
  height: 730px;
  position: absolute;
  z-index: 1;
}
.its-banner{
  position: absolute;
  top: 146px;
}
.its-tab-item.left .its-banner{
  left: 472px;
}
.its-tab-item.right .its-banner{
  right: 474px;
}
.its-logo,
.its-desc-items{
  position: absolute;
  top: 167px;
}
.its-desc-items{
  top: 304px;
}
.its-tab-item.left .its-logo,
.its-tab-item.left .its-desc-items{
  left: 117px;
}
.its-tab-item.right .its-logo,
.its-tab-item.right .its-desc-items{
  left: 353px;
}
@media screen  and (max-width: 1280px){
  .its-tab-item{
    height: 530px;
    margin-top: -265px;
  }
  .its-info-bg{
    width: 550px;
    height: 530px;
  }
  .its-banner{
    top: 96px;
  }
  .its-tab-item.left .its-banner{
    left: 400px;
  }
  .its-tab-item.right .its-banner{
    right: 425px;
  }
  .its-logo,
  .its-desc-items{
    top: 115px;
  }
  .its-desc-items{
    top: 220px;
  }
  .its-tab-item.left .its-logo,
  .its-tab-item.left .its-desc-items{
    left: 110px;
  }
  .its-tab-item.right .its-logo,
  .its-tab-item.right .its-desc-items{
    left: 177px;
  }
}
@media screen and (min-width: 1280px) and (max-width: 1560px){
  .its-tab-item{
    width: 1200px;
    height: 630px;
    margin-top: -315px;
  }
  .its-info-bg{
    width: 650px;
    height: 630px;
  }
  .its-banner{
    top: 108px;
  }
  .its-tab-item.left .its-banner{
    left: 448px;
  }
  .its-tab-item.right .its-banner{
    right: 456px;
  }
  .its-logo,
  .its-desc-items{
    top: 140px;
  }
  .its-desc-items{
    top: 260px;
  }
  .its-tab-item.left .its-logo,
  .its-tab-item.left .its-desc-items{
    left: 117px;
  }
  .its-tab-item.right .its-logo,
  .its-tab-item.right .its-desc-items{
    left: 277px;
  }
}
@media screen and (min-width: 1560px){
  .its-tab-item{
    position: absolute;
    width: 1200px;
    height: 730px;
    margin: 0 auto;
    top: 50%;
    margin-top: -365px;
    left: 0;
    right: 0;
  }
  .its-info-bg{
    width: 750px;
    height: 730px;
    position: absolute;
    z-index: 1;
  }
  .its-banner{
    top: 113px;
  }
  .its-tab-item.left .its-banner{
    left: 472px;
  }
  .its-tab-item.right .its-banner{
    right: 474px;
  }
  .its-logo,
  .its-desc-items{
    position: absolute;
    top: 167px;
  }
  .its-desc-items{
    top: 304px;
  }
  .its-tab-item.left .its-logo,
  .its-tab-item.left .its-desc-items{
    left: 117px;
  }
  .its-tab-item.right .its-logo,
  .its-tab-item.right .its-desc-items{
    left: 353px;
  }
}
</style>